<template>
    <div v-padding="3">
        <v-stepper-content v-margin="0">
            <v-text type="subheadling">
                Заполните поля
            </v-text>
        </v-stepper-content>

        <v-form :validate="validate" @submit="handleSubmit" :readonly="isRequestCreating">
            <template scope="api">
                <v-stepper-content>
                    <v-row>
                        <v-col xs="6">
                            <v-form-input
                                v-if="!isIndividual"
                                v-margin.bottom="2"
                                field="orgInnAndOgrn"
                                type="number"
                                maxlength="13"
                                required
                                label="ИНН или ОГРН"
                            />

                            <v-form-input
                                v-if="isIndividual"
                                v-margin.bottom="2"
                                field="ipInn"
                                type="number"
                                maxlength="12"
                                required
                                label="ИНН"
                            />
                        </v-col>
                    </v-row>
                </v-stepper-content>

                <v-stepper-label icon="error">
                    <v-text type="subheadling">
                        Итого: {{ total }} руб
                    </v-text>
                </v-stepper-label>

                <v-stepper-content>
                    <v-spinner :active="isRequestCreating">
                        <v-button type="submit" primary :disabled="api.isInvalid || isRequestCreating">
                            Выполнить запрос
                        </v-button>
                    </v-spinner>
                </v-stepper-content>
            </template>
        </v-form>
    </div>
</template>

<script>
    import {
        validate,
        isRequired,
        isInn, isIndividualInn,
        isOgrn,
    } from '../../../services/validator';

    const individualRules = {
        ipInn: [isRequired, isIndividualInn],
    };

    const companyRules = {
        orgInnAndOgrn: [
            (val) => isRequired(val, 'Введите ИНН или ОГРН'),
            (val) => val.toString().length <= 10
                ? isInn(val)
                : isOgrn(val),
        ],
    };

    export default {
        name: 'inn-form',
        props: {
            onCreate: Function,
            isIndividual: Boolean,
            total: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                isRequestCreating: false,
            }
        },
        methods: {
            validate(values) {
                return validate(values, this.isIndividual ? individualRules : companyRules)
            },

            fieldIsRender(field) {
                return this.fields.hasOwnProperty(field);
            },

            fieldIsRequired(field) {
                return this.fields[field].required;
            },

            handleSubmit(fields) {
                if (this.isRequestCreating) {
                    return;
                }

                this.isRequestCreating = true;

                this.onCreate({ fields })
                    .then((res) => {
                       this.$router.push({ name: 'requests' });
                    });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// InnForm.vue?0bdc83ce